import { render, staticRenderFns } from "./MovieGoBack.vue?vue&type=template&id=43ba2e12&scoped=true"
import script from "./MovieGoBack.vue?vue&type=script&lang=js"
export * from "./MovieGoBack.vue?vue&type=script&lang=js"
import style0 from "./MovieGoBack.vue?vue&type=style&index=0&id=43ba2e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ba2e12",
  null
  
)

export default component.exports